export function isNodeTag(el, tag) {
  if (tag) {
    return el.tagName === tag || el.nodeName === tag;
  }
  return false;
}
